import request from '@/utils/request'

export function sendSms (params) {
  return request({
    method: 'get',
    params: {
      r: 'phone/no-login',
      ...params
    }
  })
}

export function sendReSms (params) {
  return request({
    method: 'get',
    params: {
      r: 'phone/check-phone-and-send',
      ...params
    }
  })
}

export function sendBindSms (params) {
  return request({
    method: 'get',
    params: {
      r: 'phone/get-on-login',
      ...params
    }
  })
}
